module.exports = __webpack_public_path__ + "img/feature-desktop.fa6e0011.jpg";